import { Card, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTable from "examples/Tables/DataTable";
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { toDateReqFormat, toDateTime } from "utils/DateUtils";
import { post } from "utils/WebService";
import LogRoboEditalDetail from "./LogRoboEditalDetail";
import { ESCURO } from "assets/coresTema";


export default function LogRoboEditalConsult() {

    const today = new Date();
    const formattedDate = toDateReqFormat(today, 'yyyy-MM-dd');

    const { roboEditalStatus } = useUser();

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        dataInicio: formattedDate,
        dataFim: formattedDate,
        status: null,
        estado: '',
        grupo: '',
        equipe: ''
    });

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [dados, setDados] = useState(null);
    const [header, setHeader] = useState(null);

    const [filters, setFilters] = useState({
        empresa: null,
        status: null,
        estado: '',
        grupo: '',
        equipe: ''
    });

    const [refresh, setRefresh] = useState(false);
    const [recordsTotal, setRecordsTotal] = useState(0);

    useEffect(() => {
        fetchData({ ...tableState });
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered, status, dateInit, dateEnd, estado,
        grupo, equipe
    }) => {
        setLoadingTable(true);
        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
            dataInicio: dateInit ? dateInit : tableState.current.dataInicio,
            dataFim: dateEnd ? dateEnd : tableState.current.dataFim,
            estado: (estado || estado == '') ? estado : tableState.current.estado,
            grupo: (grupo || grupo == '') ? grupo : tableState.current.grupo,
            equipe: (equipe || equipe == '') ? equipe : tableState.current.equipe,
            status: (status || status?.code == "todos" || status == 0) ? status?.id : tableState.current.status
        };

        tableState.current = updatedTableState;

        post("/robo/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
            dataInicio: updatedTableState.dataInicio,
            dataFim: updatedTableState.dataFim,
            status: updatedTableState.status,
            estado: updatedTableState.estado,
            grupo: updatedTableState.grupo,
            equipe: updatedTableState.equipe,
        }).then(({ data, pages, recordsTotal }) => {
            setPages(pages);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
        }).catch(() => setLoadingTable(false));

        setRefresh(false);

    }, [refresh]);

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
    }

    const handleRefresh = () => {
        setRefresh(true);
    };

    const userColumns = [
        {
            header: "estado",
            accessorKey: "estado",
            cell: info => <DefaultCell>{info.getValue()}</DefaultCell>,
            isSorted: true
        },
        {
            header: "grupo",
            accessorKey: "grupo",
            cell: info => <DefaultCell>{info.getValue()}</DefaultCell>,
            isSorted: true
        },
        {
            header: "equipe",
            accessorKey: "equipe",
            cell: info => <DefaultCell>{info.getValue()}</DefaultCell>,
            isSorted: true
        },
        {
            header: "status",
            accessorKey: "roboEditalStatus",
            cell: info => {
                const status = info.getValue();
                const scheduleStatusName = roboEditalStatus?.find(ht => ht.code === status);
                return <DefaultCell>{scheduleStatusName ? scheduleStatusName.name : "-"}</DefaultCell>
            },
            isSorted: false
        },
        {
            header: "processado",
            accessorKey: "processado",
            cell: info => <DefaultCell>{String(info.getValue() || 0)}</DefaultCell>,
            isSorted: true
        },
        {
            header: "erro",
            accessorKey: "erro",
            cell: info => <DefaultCell>{String(info.getValue() || 0)}</DefaultCell>,
            isSorted: true
        },
        {
            header: "início",
            accessorKey: "dataInicio",
            cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "fim",
            accessorKey: "dataFim",
            cell: info => <DefaultCell>{toDateTime(info.getValue()) || '-'}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Dados",
            accessorKey: "dados",
            cell: info => {
                const dados = info.getValue();
                const isDisabled = !dados;

                return (
                    <>
                        <IconButton
                            onClick={() => handleOpenModal(dados, 'Dados')}
                            disabled={isDisabled}
                            sx={{
                                opacity: isDisabled ? 0.5 : 1,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                            }}  >
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>description</Icon>
                            </MDTypography>
                        </IconButton>
                    </>
                );
            },
        },
        {
            header: "ações",
            accessorKey: "id",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Ver detalhes">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.getValue());
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>visibility</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "10%"
        },
    ];

    const handleApplyFilter = (values) => {
        fetchData({
            ...tableState, pageIndex: 0, status: values?.status,
            dateInit: values?.dataInicio, dateEnd: values?.dataFim, estado: values?.estado,
            grupo: values?.grupo, equipe: values?.equipe
        });
    };

    const handleCleanFilter = () => {
        let updatedTableState = {}


        setFilters(prevFilters => ({
            ...prevFilters,
            status: null,
            estado: '',
            grupo: '',
            equipe: ''
        }));

        setData([])
        updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            dataInicio: formattedDate,
            dataFim: formattedDate,
            status: null,
            estado: '',
            grupo: '',
            equipe: ''
        };
        tableState.current = updatedTableState;
        fetchData({
            ...tableState
        });

    };

    const handleOpenModal = (dados, header) => {
        setDados(dados);
        setHeader(header);
        setIsModal(true);
    };

    const handleCloseModal = () => {
        setIsModal(false);
        setDados(null);
        setHeader(null);
    };

    return (
        <Grid container display="flex" justifyContent="center">

            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <LogRoboEditalDetail
                        scheduleId={selectedId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh} />
                </Grid>
            }

            {isModal &&
                <MDModal
                    header={header}
                    dados={dados}
                    show={isModal}
                    close={handleCloseModal}
                />
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? ESCURO.cartao : "#fafafa",
                        borderColor: darkMode ? ESCURO.divisoria : "#ddd",
                    }}
                >
                        <Formik
                            initialValues={{
                                status: null,
                                dataInicio: formattedDate,
                                dataFim: formattedDate,
                                estado: '',
                                grupo: '',
                                equipe: ''
                            }}
                            onSubmit={(values) => handleApplyFilter(values)}>
                            {({ values, setFieldValue, resetForm }) => (
                                <Form>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Estado</InputLabel>
                                            <MDInput
                                                size="small"
                                                placeholder="Digite o estado"
                                                value={values.estado}
                                                onChange={({ target }) => setFieldValue("estado", target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleApplyFilter(values);
                                                    }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Grupo</InputLabel>
                                            <MDInput
                                                size="small"
                                                placeholder="Digite o grupo"
                                                value={values.grupo}
                                                onChange={({ target }) => setFieldValue("grupo", target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleApplyFilter(values);
                                                    }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Equipe</InputLabel>
                                            <MDInput
                                                size="small"
                                                placeholder="Digite o equipe"
                                                value={values.equipe}
                                                onChange={({ target }) => setFieldValue("equipe", target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleApplyFilter(values);
                                                    }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                                            <MDSelect
                                                isMulti={false}
                                                getOptionValue={(option) => option.code}
                                                getOptionLabel={(option) => option.name}
                                                name="status"
                                                placeholder="Todos"
                                                value={values.status || null}
                                                options={roboEditalStatus}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("status", selectedOption)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Início</InputLabel>
                                            <MDTextFieldCalendar
                                                size="small"
                                                type="date"
                                                value={values.dataInicio || ""}
                                                fullWidth
                                                onChange={(event) => setFieldValue("dataInicio", event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                darkMode={darkMode}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Fim</InputLabel>
                                            <MDTextFieldCalendar
                                                size="small"
                                                type="date"
                                                value={values.dataFim || ""}
                                                fullWidth
                                                onChange={(event) => setFieldValue("dataFim", event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                darkMode={darkMode}
                                            />
                                        </Grid>
                                        <Grid item xs={12} display="flex" justifyContent="end" pt={1}>
                                            <MDBox>
                                                <MDButton
                                                    size="medium"
                                                    sx={{ marginRight: 2 }}
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={() => {
                                                        resetForm({
                                                            values: {
                                                                ...values,
                                                                status: null,
                                                                dataInicio: formattedDate,
                                                                dataFim: formattedDate,
                                                                estado: '',
                                                                grupo: '',
                                                                equipe: ''
                                                            },
                                                        });
                                                        handleCleanFilter();
                                                    }}
                                                >
                                                    Limpar filtro
                                                </MDButton>
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    type="submit"
                                                >
                                                    Aplicar filtro
                                                </MDButton>
                                            </MDBox>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={data}
                    fetchData={fetchData}
                    totalPages={pages}
                    totalRecords={recordsTotal}
                    tableState={tableState} />
            </Grid>
        </Grid >
    );
}
